import type { CollectedIntegrationConfig } from '@cli-types/next-adapter/runtime.js'
import { resolvePasswordEnvValue } from './resolve-password-env-value.js'
import { resolveTextEnvValue } from './resolve-text-env-value.js'

export async function collectResendConfig(cwd: string): Promise<CollectedIntegrationConfig> {
  const overwriteEnvKeys = new Set<string>()
  const apiKey = await resolvePasswordEnvValue({
    cwd,
    key: 'BETTERSTART_RESEND_API_KEY',
    message: 'Resend API key',
    cancelMessage: 'Resend configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim()) {
        return 'Enter a Resend API key.'
      }
    }
  })
  const fromAddress = await resolveTextEnvValue({
    cwd,
    key: 'BETTERSTART_EMAIL_FROM',
    message: 'From email address',
    defaultValue: 'noreply@yourdomain.com',
    cancelMessage: 'Resend configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim() || !value.includes('@')) {
        return 'Enter a valid sender email address.'
      }
    }
  })

  return {
    sections: [
      {
        header: 'Email (Resend)',
        vars: [
          { key: 'BETTERSTART_RESEND_API_KEY', value: apiKey.trim() },
          { key: 'BETTERSTART_EMAIL_FROM', value: fromAddress.trim() }
        ]
      }
    ],
    overwriteKeys: overwriteEnvKeys
  }
}
